import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { getIsAgency, isUserAdNetwork } from '../../selectors/user';
import { IconSizes, IconVariants } from '../foundations/Icon';
import Tooltip from './Tooltip';
import { Icon } from '../widgets';
import css from './AgencyIndicator.css';

const AgencyIndicator = ({
    hasMissingAgencies = false,
    hasAgency = false,
    missingAgencyTooltipKey = '',
    hasAgencyTooltipKey = '',
}) => {
    const isAgency = useSelector(getIsAgency);
    const isPartner = useSelector(isUserAdNetwork);

    if (isAgency || isPartner) {
        return null;
    }

    return (
        <div className={css.container}>
            {hasMissingAgencies && (
                <Tooltip titleTranslationKey={missingAgencyTooltipKey}>
                    <Icon name="alert-triangle" size={IconSizes.X_SMALL} variant={IconVariants.WARNING} />
                </Tooltip>
            )}
            {hasAgency && (
                <Tooltip titleTranslationKey={hasAgencyTooltipKey}>
                    <Icon name="briefcase" size={IconSizes.X_SMALL} variant={IconVariants.LIGHT} />
                </Tooltip>
            )}
        </div>
    );
};

AgencyIndicator.propTypes = {
    hasMissingAgencies: PropTypes.bool,
    hasAgency: PropTypes.bool,
    missingAgencyTooltipKey: PropTypes.string,
    hasAgencyTooltipKey: PropTypes.string,
};

export default AgencyIndicator;
